import { H2RButton, H2RCheckbox, H2RInput, H2RSelect } from "../../imports";

export const GraphicEditor = ({ cue, media, onUpdate }) => {
	return (
		<>
			<H2RCheckbox
				label="Map interactable"
				// hint={cue.interactable && "Disable to 'Save PNG'"}
				checkboxLabel={cue.interactable ? "Interaction on" : "Interaction off"}
				checked={cue.interactable || false}
				onChange={(change) => {
					onUpdate({ interactable: change });
				}}
			/>
			<H2RSelect
				selected={cue.mapType || "terrain"}
				label="Map type"
				options={[
					{
						label: "Terrain",
						value: "terrain",
					},
					{
						label: "Hybrid",
						value: "hybrid",
					},
					{
						label: "Satellite",
						value: "satellite",
					},
					{
						label: "Roadmap",
						value: "roadmap",
					},
				]}
				onChange={(value) => {
					onUpdate({ mapType: value });
				}}
			/>
			<div className="flex gap-2">
				<H2RInput
					label="Zoom"
					type="number"
					min={1}
					max={10}
					value={cue.zoomLevel || 4}
					onChange={(value) => {
						onUpdate({zoomLevel: value});
					}}
				/>
				<H2RInput
					label="Lat"
					type="number"
					min={-90}
					step={0.5}
					max={90}
					value={cue.lat || 51.5}
					onChange={(value) => {
						onUpdate({lat: value});
					}}
				/>
				<H2RInput
					label="Long"
					type="number"
					min={-180}
					step={0.5}
					max={180}
					value={cue.long || 0}
					onChange={(value) => {
						onUpdate({long: value});
					}}
				/>
			</div>

			<span className="border-b border-gray-700 w-full inline-block bg-gray-400"></span>

			<H2RButton
				text="Remove all pins"
				colour="dark"
				size="small"
				onClick={() => {
					onUpdate({removePinCount: new Date().getTime()});
				}}
			/>
		</>
	);
};

export const GraphicCueContent = ({
	cue,
	dynamicText,
	dynamicLists,
	twoLines,
}) => {
	return "Map";
};
